//@flow
import * as React from 'react';
import {baseClass} from "../../../../pages/UiKit/newUiKit/utilities/baseClass";
import type {children, id} from "../../../../services/flowTypes/appFlowTypes";
import type {addClasses} from "../../../../services/flowTypes/uiKitFlowTypes";
import './Heading5.css';

type Props = {
  id?: id,
  addClasses?: addClasses,
  children: children
};

const Heading5 = (props: Props) => {
  return (
    <div id={props.id} className={baseClass("Heading5", props.addClasses)}>{props.children}</div>
  );
};

export default Heading5;